// src/pages/SendKeys.jsx
import React from 'react';
import PageLayout from '../components/PageLayout';
import styles from '../styles/SendKeys.module.css'; // only input styles

const SendKeys = () => {
  return (
    <PageLayout
      title="📝 TEXTBOX INTERACTIONS"
      sidebarContent={
        <ul>
          <li>✏️ Enter text by command <b>SendKeys</b></li>
          <li>➕ Append text using <b>SendKeys</b></li>
          <li>🔍 Use <b>getAttribute</b> to fetch default value</li>
          <li>🧹 Use <b>Clear</b> method to clear text</li>
        </ul>
      }
    >
      <div className={styles.row}>
        <div className={styles.inputGroup}>
          <label htmlFor="email">EMAIL</label>
          <input type="email" id="email" class="input" name="bst_email" placeholder="yourEmail@domain.com" />
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="append">APPEND TEXT</label>
          <input type="text" id="append" class="input" name="bst_press" defaultValue="APPEND" />
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="default_text">GET DEFAULT TEXT</label>
          <input type="text" id="default_text" class="input" name="bst_default" defaultValue="BALAMURUGAN" />
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="clear_text">CLEAR TEXT !!!</label>
          <input type="text" id="clear_text" class="input" name="bst_clear" defaultValue="CLEAR ME !!!" />
        </div>
        <div className={styles.inputGroupFull}>
          <label htmlFor="disabled">TEXT FIELD IS DISABLED</label>
          <input type="text" id="disabled" class="input" name="bst_disabled" disabled />
        </div>
      </div>
    </PageLayout>
  );
};

export default SendKeys;
